import React, { FC, memo, useMemo } from 'react';
import { List } from 'udesk-ui';
import Ellipsis from 'src/components/common/Ellipsis';
import { transformData } from './const';
import { FieldFoundAdvanceWrapperResponse, FieldFoundResponse } from 'src/api/types';

export interface TemplateProps {
    queryData?: FieldFoundAdvanceWrapperResponse[];
    inspectDataSource?: number;
    onChooseField?: (inspectDataSource?: number, type?: number, field?: FieldFoundResponse) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { queryData, inspectDataSource, onChooseField } = props;

    const dataSource = useMemo(() => {
        return transformData({
            data: queryData || [],
            inspectDataSource: inspectDataSource!,
        });
    }, [inspectDataSource, queryData]);

    return (
        <List
            size="small"
            dataSource={dataSource}
            renderItem={(categary) => (
                <div style={{ marginBottom: 4 }}>
                    <div>
                        <Ellipsis
                            style={{ color: 'rgba(0, 0, 0, 0.25)' }}
                            text={categary.typeName}
                        />
                    </div>

                    <List
                        size="small"
                        dataSource={categary.fieldList}
                        renderItem={(field) => {
                            const fieldPlaceholder = `[${field.label}]`;

                            return (
                                <div
                                    style={{
                                        marginBottom: 2,
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                    }}
                                    onClick={() =>
                                        onChooseField?.(inspectDataSource, categary.type, field)
                                    }
                                >
                                    <Ellipsis text={fieldPlaceholder} />
                                </div>
                            );
                        }}
                    />
                </div>
            )}
        />
    );
});

export default Template;
